export default "__VITE_ASSET__CXQCHvLG__"